import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5699fdf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Item = _resolveComponent("Item")!

  return (!_ctx.token)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, "Loading..."))
    : (_openBlock(), _createElementBlock("main", _hoisted_2, [
        _createVNode(_component_Item, {
          title: "Credentials",
          redirectTo: "/credentials",
          itemsCount: _ctx.credentialsCount
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-key" })
          ]),
          _: 1
        }, 8, ["itemsCount"]),
        _createVNode(_component_Item, {
          title: "Notes",
          redirectTo: "/notes",
          itemsCount: _ctx.notesCount
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-book" })
          ]),
          _: 1
        }, 8, ["itemsCount"]),
        _createVNode(_component_Item, {
          title: "Cards",
          itemsCount: _ctx.cardsCount,
          redirectTo: "/cards"
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-wallet" })
          ]),
          _: 1
        }, 8, ["itemsCount"]),
        _createVNode(_component_Item, {
          title: "Wifi",
          redirectTo: "/wifis",
          itemsCount: _ctx.wifiCount
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-wifi" })
          ]),
          _: 1
        }, 8, ["itemsCount"]),
        _createVNode(_component_Item, {
          title: "Documents",
          redirectTo: "/documents",
          itemsCount: _ctx.documentsCount
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-address-card" })
          ]),
          _: 1
        }, 8, ["itemsCount"]),
        _createElementVNode("div", {
          class: "icon add-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/new')))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-plus" })
        ])
      ]))
}